import axios, { AxiosError, AxiosResponse } from "axios";
import config from "./config";

const _axiosInstance = axios.create({
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

_axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError<AxiosResponse>) => {
    switch (error.response?.status) {
      case 401:
      case 403: {
        window.location.replace(
          `${
            config.USER_MANAGEMENT_URL
          }/select?redirectUrl=${encodeURIComponent(window.location.href)}`
        );
        break;
      }
      default: {
        // Disabling error redirect until all api endpoints have been enabled
        // const { pathname } = window.location;
        // const urlSegments = pathname.split("/");
        // window.location.replace(
        //   `/company/${urlSegments[2]}/dataConnection/${urlSegments[4]}${URLS.ERROR_PAGE}`
        // );
      }
    }
    return Promise.reject(error.response);
  }
);

export interface IBroker {
  Fetch(url: string, token: string): Promise<AxiosResponse["data"]>;
}

export class Broker implements IBroker {
  public Fetch = async (url: string, token: string) => {
    const response = await _axiosInstance.get(
      `${config.CONNECTORS_API_URL}/${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  };
}
